import * as Toastr from "toastr";
import {InitPage} from "../../index";
import swal from "sweetalert";
import {ElcProductionReporting} from "./reporting";


declare var saveProductionInCard;
declare var runningTime;
declare var productionStatus;

export class ElcProductionCards {
    constructor() {
        const _this = this;

        InitPage("index", () => {
            if(productionStatus == "in_process" || productionStatus == "pre_assembly") {
                setInterval(_this.show_time, 1000);
            }
        });

        $('#start-job-btn').on('click',() => {
            var type = $('#start-job-btn').attr('data-message');
            this.display_error(type);
        });

        $("#show-attachments").on("click", () => {
            $("#attachments-list").modal("show");
        });

        $("#add-produced-qty-btn").on("click", () => {
            $(".add-report-production-form").modal("show");
        });

        $("#add-report-production-submit").on("click", () => {
            $(".add-report-production-form").modal("hide");
        });

        $("#complete_job_btn").on("click", () => {
            $(".add-complete-job-form").modal("show");
        });

        $("#add-complete-job-form-submit").on("click", () => {
            $(".add-complete-job-form").modal("hide");
        });

        $("#pause_job_btn").on("click", () => {
            $(".add-pause-job-form").modal("show");
        });

        $("#add-pause-job-form-submit").on("click", () => {
            $(".add-pause-job-form").modal("hide");
        });

        $("#start-assembly").on("click", () => {
            const e_msg = $('#start-assembly').attr('data-message');
            if(e_msg == undefined) {
                $(".add-assembly-job-form").modal("show");
            } else {
                this.display_error(e_msg);
            }
        });

        // $("#add-assembly-job-form-submit").on("click", () => {
        //     $(".add-assembly-job-form").modal("hide");
        // });

        $("#end_shift_job_btn").on("click", () => {
            $(".end-shift-job-form").modal("show");
        });

        $("#end-shift-job-form").on("click", () => {
            $(".end-shift-job-form").modal("hide");
        });

        $("#manager").on("change", () => {
            const avatarPath = $("#manager :selected").attr("data-avatar");
            $("#manager-avatar").attr("src", avatarPath);
        });

        $("#supervisor").on("change", () => {
            const avatarPath = $("#supervisor :selected").attr("data-avatar");
            $("#supervisor-avatar").attr("src", avatarPath);
        });

        $("#supervisor").on('change', function(){
            $.ajax({
                url: saveProductionInCard,
                data: { elc_production_params: {
                        supervisor_employee_id: $("#supervisor").val() } },
                method: "PUT"
            }).then((response) => {
                if (response.success == "ok") {
                    Toastr.success('Supervisor saved', "Saved");
                } else {
                    Toastr.error(response.error, "Error");
                }
            });
        });

        $("#manager").on('change', function(){
            $.ajax({
                url: saveProductionInCard,
                data: { elc_production_params: {
                    manager_employee_id: $("#manager").val() } },
                method: "PUT"
            }).then((response) => {
                if (response.success == "ok") {
                    Toastr.success('Manager saved', "Saved");
                } else {
                    Toastr.error(response.error, "Error");
                }
            });
        });


        $("#elc-note").on('change', function(){
            $.ajax({
                url: saveProductionInCard,
                data: { elc_production_params: {
                    note: $("#elc-note").val() } },
                method: "PUT"
            }).then((response) => {
                if (response.success == "ok") {
                    Toastr.success('Note saved', "Saved");
                } else {
                    Toastr.error(response.error, "Error");
                }
            });
        });

    }

    display_error(type) {
        switch(type)
        {
            case 'manager':
                swal("Error","A manager is not defined for the production card. Select a Manager and click on Save.", "warning");
                break;
            case 'supervisor':
                swal("Error","A supervisor is not defined for the production card. Select a Supervisor and click on Save.", "warning");
                break;
            case 'future':
                swal("Error","You cannot start this production, because your current time and date does not match the scheduled time and date. If you want to be able to start, you need to update the schedule to today’s date.", "warning");
                break;
        }
    }

    show_time() {
        ++runningTime;
        let hour = Math.floor(runningTime / 3600);
        let minute = Math.floor((runningTime - hour * 3600) / 60);
        let seconds = runningTime - (hour * 3600 + minute * 60);
        $("#timer").html(String(hour).padStart(2, "0") + ":" + String(minute).padStart(2, "0") + ":" + String(seconds).padStart(2, "0") );
    }
}

export function LoadPage() {
    InitPage("elc productions", () => {
        InitPage("cards", () => {
            const c = new ElcProductionCards();
            const n = new ElcProductionReporting();
        });
    });
}
